var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.726,
    height: 27.175,
    viewBox: "0 0 24.726 27.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_5402434_send_upload_arrow_export_ui_icon",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    d: "M24.978 23.549H5.747A2.893 2.893 0 0 1 3 20.529V17.51A1.447 1.447 0 0 1 4.374 16a1.447 1.447 0 0 1 1.374 1.51v3.019h19.23V17.51a1.38 1.38 0 1 1 2.747 0v3.019a2.893 2.893 0 0 1-2.747 3.02z",
    className: "cls-1",
    transform: "translate(0 6.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    d: "M22.857 6.019H6.374A1.447 1.447 0 0 1 5 4.51 1.447 1.447 0 0 1 6.374 3h16.483a1.447 1.447 0 0 1 1.374 1.51 1.447 1.447 0 0 1-1.374 1.509z",
    className: "cls-1",
    transform: "translate(0.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    d: "M18.59 11.964l-4.121-4.529a1.365 1.365 0 0 0-.453-.317 1.26 1.26 0 0 0-1.044 0 1.365 1.365 0 0 0-.453.317L8.4 11.964a1.621 1.621 0 0 0-.288 1.646 1.38 1.38 0 0 0 1.264.936h2.744v4.529a1.447 1.447 0 0 0 1.374 1.51 1.447 1.447 0 0 0 1.374-1.51v-4.529h2.747a1.38 1.38 0 0 0 1.264-.936 1.621 1.621 0 0 0-.289-1.646z",
    className: "cls-1",
    transform: "translate(1.869 2.041)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.04690cabe0c55e333a8d54f2c8383407.svg";
export { ForwardRef as ReactComponent };